import axios from 'axios';

const updateGroups = ({ url, ...params }) => {
  return axios.put(url, params);
};

export { updateGroups };
